// Spec 2026-10-21 §1.1 (owner decision D1): coupon codes match whatever
// their letter case. A code is trimmed and compared lower-cased, the rule
// the API's CouponCodeKey applies. A blank code matches nothing.
const codeKey = (code) => {
  if (typeof code !== 'string') return null;
  const key = code.trim().toLowerCase();
  return key === '' ? null : key;
};

// Whether two codes are the same coupon code, whatever their letter case and
// surrounding spaces.
export const sameCode = (a, b) => {
  const key = codeKey(a);
  return key !== null && key === codeKey(b);
};

// The campaign of `campaigns` (a PublicCoupon/GetAvailable list) whose code
// is `typed`, or null. The first match wins; codes are unique per company.
export const findCampaignByCode = (campaigns, typed) =>
  (Array.isArray(campaigns) ? campaigns : []).find((c) =>
    sameCode(c?.code, typed),
  ) ?? null;

// CouponCard's lock (CouponSlider.jsx): a spend-to-unlock campaign (types 0
// and 1 with a minimum) cannot be applied below its minimum spend. A typed
// code is held to the same rule.
export const belowMinimumSpend = (coupon, subtotal) =>
  (coupon?.type === 0 || coupon?.type === 1) &&
  coupon.minprice > 0 &&
  (subtotal || 0) < coupon.minprice;

// What a spend-to-unlock campaign unlocks, in the words of the minimum-spend
// line (useCouponMinPriceInfo reads it too): "Free item", "10% off", "$5 off".
export const minSpendReward = (coupon) => {
  if (coupon?.type === 0) return 'Free item';
  return coupon?.discounttype === 0
    ? `${coupon?.discountamount}% off`
    : `$${coupon?.discountamount} off`;
};

// The payment page's minimum-spend line (Payment.jsx), for a campaign that
// `subtotal` has not unlocked: "Add $18.00 more to unlock $5 off". A typed
// code below its minimum is valid, so it gets this line, not the invalid
// sentence (spec 2026-10-21 §3, Review Focus 4).
export const minimumSpendSentence = (coupon, subtotal) =>
  `Add $${(coupon.minprice - (subtotal || 0)).toFixed(2)} more to unlock ${minSpendReward(coupon)}`;
